import { useAuth } from "@/lib/config/auth-provider";

/**
 * Connected sources (RND-2977). Same flag the backend resolves onto
 * `user.featureFlags.agentHandler`. The deployment switch is enforced by the
 * API: a flag-on workspace whose server is off gets an empty miss.
 */
export function useAgentHandlerEnabled(): boolean {
  const { user } = useAuth();
  return user?.featureFlags?.agentHandler === true;
}
